const getToken = state => state.token;
const getUser = state => state.user;
const getIdPuntoVenta = state => state.idPuntoVenta;
const getConsultar = state => state.consultar;
const getCompany = state => state.company;

export default {
  getToken,
  getUser,
  getIdPuntoVenta,
  getConsultar,
  getCompany
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js